<template>
  <div class="ic-form__r-01"> 111
    <FormWrapper :validator="$v.form">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-8">
          <p class="mbm alert alert-warning" v-html="$t('form_r01_introtext')"></p>
        </div>
      </div>

      <IcFormContactName v-model="form.name" />
      <IcFormContactEmail v-model="form.email" :withAgreement="true" @update:agreement="form.emailAgreement = $event"
        @update:pollAgreement="form.pollAgreement = $event" />
      <IcFormContactPhone v-model="form.phone" />
      <IcFormContactAddress v-model="form.address" />

      <IcFormContactConnection v-model="form.connection" :minDate="minDate" :endDate="endDate" :withAlert="true" />

      <h3>Wiadomość</h3>
      <IcFormContactMessage v-model="form.message" />
      <IcFormRowWrapper id="bankTransfer" :labelWidth="4" :controlWidth="8">
        <template slot-slope="{validator}">
          <IcCheckbox id="bankTransfer" v-model="form.bankTransfer" :val="1"> podaję numer mojego rachunku bankowego do
            zwrotu</IcCheckbox>
        </template>
      </IcFormRowWrapper>
      <IcFormContactBank v-model="form.bank" v-if="form.bankTransfer == 1" introtext="form_bank_introtext_2" />

      <IcFormContactFiles v-model="form.files" />
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"
        :is_visible="false" :value="true" :label="$t('label_agreement_checkbox')" content="form_agreement_r">
      </IcFormAgreements>
      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormComplaintBase from "./Base/ComplaintBase";
import IcFormContactName from "./Base/Name";
import IcFormContactEmail from "./Base/Email";
import IcFormContactPhone from "./Base/Phone";
import IcFormContactAddress from "./Base/Address";
import IcFormContactBank from "./Base/Bank";
import IcFormContactMessage from "./Base/Message";
import IcFormContactFiles from "./Base/Files";
import IcFormR01Connection from "./Base/R01Connection";
import IcFormContactConnection from "./Base/Connection";
import IcFormAgreements from "./Base/Agreements";
import IcFormButtons from "./Base/Buttons";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox";
import validations from "./Validation/r_01.js";
import { Name } from "./Model/Name";
import { Address } from "./Model/Address";
import { Connection } from "./Model/Connection";
import { Bank } from "./Model/Bank";
import moment from "moment";

export default {
  name: "IcFormComplaintR01",
  extends: IcFormComplaintBase,
  validations,
  data() {
    return {
      minDate: moment()
        .add(-1, "years")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .add(1, "years")
        .format("YYYY-MM-DD"),
      form: {
        type: "r01",
        name: new Name(),
        emailAgreement: 0,
        phone: "",
        bank: new Bank(),
        bankTransfer: 0,
        connection: new Connection(),

        address: new Address(),
        agreement: 1
      }
    };
  },
  components: {
    IcFormContactName,
    IcFormContactPhone,
    IcFormContactEmail,
    IcFormContactBank,
    IcFormR01Connection,
    IcFormContactConnection,
    IcFormContactAddress,
    IcFormContactMessage,
    IcFormContactFiles,
    IcFormAgreements,
    IcFormButtons,
    IcCheckbox
  }
};
</script>

<style></style>
